import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { SupplierProductAddForm } from "../form/SupplierProductAddForm";


type SupplierProductAddDrawerProps = {


  isSupplierProductDrawerOpen: boolean;
  closeDrawerAction: () => void;
};


export const SupplierProductAddDrawer: React.FC<
SupplierProductAddDrawerProps
> = ({ closeDrawerAction,   isSupplierProductDrawerOpen }) => {
  const { t } = useTranslation();

  
 

  return (

    <Drawer
      title={t("supplierproducts.drawer.title")}
      placement="right"
      width={700}
      closable={true}
      onClose={() => closeDrawerAction()}
      open={isSupplierProductDrawerOpen}
      bodyStyle={{ padding: 10 }}

    >
    
      {isSupplierProductDrawerOpen &&
         <SupplierProductAddForm
          isSupplierProductDrawerOpen={isSupplierProductDrawerOpen}
          closeDrawerAction={closeDrawerAction}
        
          />
      }

    </Drawer>
  );
};
